module.exports = __webpack_public_path__ + "img/temperature-empty.24b03622.svg";